import './consultation-section.css';

export const ConsultationSection = () => {
    return (
        <section id="consultation-banner" className={`build-future-section`}>
            {/* Background Subtle Geometric Polygon Mesh / Constellation Lines */}
            <div className="build-future-bg-mesh" aria-hidden="true">
                <svg
                    viewBox="0 0 1440 700"
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient id="meshGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="#d97706" stopOpacity="0.12" />
                            <stop offset="50%" stopColor="#b45309" stopOpacity="0.22" />
                            <stop offset="100%" stopColor="#ea580c" stopOpacity="0.16" />
                        </linearGradient>
                        <filter id="nodeGlow" x="-20%" y="-20%" width="140%" height="140%">
                            <feGaussianBlur stdDeviation="3" result="blur" />
                            <feComposite in="SourceGraphic" in2="blur" operator="over" />
                        </filter>
                    </defs>

                    {/* Connected Polygon Wireframe Lines */}
                    <g stroke="url(#meshGradient)" strokeWidth="1.2" fill="none" opacity="0.8">
                        <polygon points="120,40 380,90 260,260" />
                        <polygon points="380,90 620,60 520,240" />
                        <polygon points="260,260 520,240 430,420" />
                        <polygon points="520,240 740,190 680,390" />
                        <polygon points="430,420 680,390 560,580" />
                        <polygon points="740,190 980,140 920,330" />
                        <polygon points="680,390 920,330 830,520" />
                        <polygon points="980,140 1200,90 1140,290" />
                        <polygon points="920,330 1140,290 1080,480" />
                        <polygon points="1140,290 1380,240 1320,440" />
                        <polygon points="1080,480 1320,440 1260,630" />

                        <line x1="120" y1="40" x2="620" y2="60" strokeOpacity="0.15" />
                        <line x1="260" y1="260" x2="140" y2="440" />
                        <line x1="140" y1="440" x2="430" y2="420" />
                        <line x1="430" y1="420" x2="310" y2="610" />
                        <line x1="310" y1="610" x2="560" y2="580" />
                        <line x1="560" y1="580" x2="830" y2="520" />
                        <line x1="830" y1="520" x2="720" y2="670" />
                        <line x1="720" y1="670" x2="1080" y2="640" />
                        <line x1="1080" y1="480" x2="1080" y2="640" />
                        <line x1="980" y1="140" x2="740" y2="190" strokeOpacity="0.3" />
                        <line x1="1200" y1="90" x2="1400" y2="60" />
                        <line x1="1400" y1="60" x2="1380" y2="240" />
                        <line x1="1380" y1="240" x2="1420" y2="410" />
                        <line x1="1320" y1="440" x2="1440" y2="580" />
                    </g>

                    {/* Glowing Constellation Node Vertices */}
                    <g fill="#f59e0b" opacity="0.65" filter="url(#nodeGlow)">
                        <circle cx="380" cy="90" r="3.5" />
                        <circle cx="520" cy="240" r="3" />
                        <circle cx="740" cy="190" r="4" />
                        <circle cx="920" cy="330" r="3.5" />
                        <circle cx="980" cy="140" r="4" />
                        <circle cx="1140" cy="290" r="3.5" />
                        <circle cx="680" cy="390" r="3" />
                        <circle cx="830" cy="520" r="3.5" />
                        <circle cx="1080" cy="480" r="4" />
                        <circle cx="1320" cy="440" r="3" />
                    </g>
                </svg>
            </div>

            <div className="build-future-container">
                {/* Left Side: Headline, Copy & Bullets */}
                <div className="build-future-content">
                    <span className="build-future-kicker">Lokalt forankret i Herlev</span>
                    <h2 className="build-future-heading" id="bf-heading-title">
                        Onlineskolemad i Herlev
                    </h2>

                    <p className="build-future-text">
                        Onlineskolemad adskiller sig fra en tilfældig ekstern leverandør ved at være lokalt baseret i Herlev.
                    </p>
                    <p className="build-future-text">
                        Virksomhedens adresse er Herlev Bygade 27, 2730 Herlev, og kontaktoplysningerne angiver også Herlev som virksomhedens base.
                    </p>
                    <p className="build-future-text">
                        Det lokale udgangspunkt er relevant, når en skole eller organisation skal finde en leverandør, der forstår den praktiske hverdag omkring levering, bestilling og udlevering.
                    </p>
                    <p className="build-future-text">
                        Herlev er samtidig tæt forbundet med resten af hovedstadsområdet. Kommunen ligger centralt i hovedstadsregionen og grænser blandt andet op til Ballerup, Gladsaxe, Rødovre, Glostrup, København og Furesø.
                    </p>
                    <p className="build-future-text">
                        For familier, skoler og organisationer i Herlev betyder det, at en lokal leverandør kan være et naturligt udgangspunkt for en madordning, mens behovet for fleksibel levering og digital bestilling stadig er centralt.
                    </p>
                </div>

                <div className="build-future-image-col">
                    <div className="build-future-image-wrapper">
                        <img
                            src="/assets/img/food-1.png"
                            alt="Healthy school lunch and meal solutions for Herlev families"
                            className="build-future-image"
                            referrerPolicy="no-referrer"
                            loading="eager"
                        />
                    </div>
                </div>
            </div>
        </section >
    );
};

export default ConsultationSection;